import * as React from 'react';

import { PopularPlace, TPopularPlace } from './PopularPlace';
import * as styles from './PopularPlaces.css';

interface IPopularPlacesProps {
  places: TPopularPlace[];
  onPlaceClick(place: TPopularPlace): void;
}

export function PopularPlaces({ places, onPlaceClick }: IPopularPlacesProps) {
  return (
    <ul className={styles['container']}>
      {places.map(place => (
        <PopularPlace key={place.title} place={place} onClick={() => onPlaceClick(place)} />
      ))}
    </ul>
  );
}
